import { useState, useEffect } from 'react';
import { useDebounce } from './useDebounce';
import { producaov2 } from '../services/apis';

export default function usePlanSearch({search = '', payment_method}) {
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const getData = async () => {
      setLoading(true);

      try {
        const response = await producaov2.get(`/admin/planos/assinatura`, {
          params: {
            search,
            payment_method,
            limit: 15
          }
        });

        if(isMounted) {
          setData(response.data?.data || []);
        }
      } catch(error) {
        setError(error);
        setData([]);
      } finally {
        if(isMounted) {
          setLoading(false);
        }
      }
    }

    getData();

    return () => {
      isMounted = false;
    }
  }, [search]);


  return {
    data,
    error,
    loading,
  }
}